export class MapPlus<K, V> extends Map<K, V> {
	mapKeys<U>(callbackfn: (key: K, index: number) => U): U[] {
		const keys: U[] = Array.from({ length: this.size });

		let i = 0;
		for (const key of this.keys()) {
			keys[i] = callbackfn(key, i);
			i++;
		}

		return keys;
	}

	mapValues<U>(callbackfn: (value: V, index: number) => U): U[] {
		const values: U[] = Array.from({ length: this.size });

		let i = 0;
		for (const value of this.values()) {
			values[i] = callbackfn(value, i);
			i++;
		}

		return values;
	}

	mapEntries<U>(callbackfn: (entry: [key: K, value: V], index: number) => U): U[] {
		const entries: U[] = Array.from({ length: this.size });

		let i = 0;
		for (const entry of this.entries()) {
			entries[i] = callbackfn(entry, i);
			i++;
		}

		return entries;
	}

	filterKeys(callbackfn: (key: K, index: number) => boolean): K[] {
		const keys: K[] = [];

		let i = 0;
		for (const key of this.keys()) {
			if (callbackfn(key, i)) keys.push(key);
			i++;
		}

		return keys;
	}

	filterValues(callbackfn: (value: V, index: number) => boolean): V[] {
		const values: V[] = [];

		let i = 0;
		for (const value of this.values()) {
			if (callbackfn(value, i)) values.push(value);
			i++;
		}

		return values;
	}

	filterEntries(
		callbackfn: (entry: [key: K, value: V], index: number) => boolean
	): [key: K, value: V][] {
		const entries: [K, V][] = [];

		let i = 0;
		for (const entry of this.entries()) {
			if (callbackfn(entry, i)) entries.push(entry);
			i++;
		}

		return entries;
	}
}
